import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function initBlockSwiperScripts(context = document) {
    // Skip inside the block editor UI
    if (document.documentElement.classList.contains('block-editor-page')) return;

    const blockSwipers = context.querySelectorAll('.gb-component-swiper');

    if (blockSwipers.length === 0) return;

    blockSwipers.forEach(blockSwiper => {
        blockSwiperInit(blockSwiper);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initBlockSwiperScripts();
});

function blockSwiperInit(blockSwiper) {
    const blockSwiperContainerSelector = '.gb-component-swiper__swiper';
    const blockSwiperWrapperClass      = 'gb-component-swiper__wrapper';

    const blockSwiperContainer = blockSwiper.querySelector(blockSwiperContainerSelector);
    if (blockSwiperContainer == null) return;

    // Ensure default Swiper classes so core CSS applies.
    blockSwiperContainer.classList.add('swiper');

    const blockSwiperWrapper = blockSwiperContainer.querySelector(`.${blockSwiperWrapperClass}`);
    if (blockSwiperWrapper == null) return;

    blockSwiperWrapper.classList.add('swiper-wrapper');

    // Make every direct child a slide.
    Array.from(blockSwiperWrapper.children).forEach(child => {
        child.classList.contains('swiper-slide') || child.classList.add('swiper-slide');
    });

    // Get slides per view values from data attributes
    const swiperSlidesData = blockSwiperContainer.dataset;
    const num = (val, fallback) => {
        const n = Number(val);
        return Number.isFinite(n) ? n : fallback;
    };

    const swiperSlidesBase = num(swiperSlidesData.swiperSlides, 1);
    const swiperSlidesMd   = num(swiperSlidesData.swiperSlidesMd, swiperSlidesBase);
    const swiperSlidesLg   = num(swiperSlidesData.swiperSlidesLg, swiperSlidesMd);
    const swiperSlidesXl   = num(swiperSlidesData.swiperSlidesXl, swiperSlidesLg);

    const swiper = new Swiper(blockSwiperContainer, {
        loop: true,
        slidesPerView: swiperSlidesBase,
        spaceBetween: 20,
        breakpoints: {
            768:  { slidesPerView: swiperSlidesMd },
            1024: { slidesPerView: swiperSlidesLg },
            1440: { slidesPerView: swiperSlidesXl },
        },
        navigation: {
            nextEl: blockSwiper.querySelector('.gb-component-swiper__button-next'),
            prevEl: blockSwiper.querySelector('.gb-component-swiper__button-prev'),
        },
        pagination: {
            el: blockSwiper.querySelector('.swiper-pagination'),
        },
    });

    blockSwiper._swiper = swiper;
}